module.exports = __webpack_public_path__ + "img/down_new_desc.1529d6e8.png";